import React from 'react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { KARITO_PHOTO, PRICE } from '../../data/content';
const conditions = ['creatinina elevata', 'TFG ridotta', 'albuminuria', 'iperkaliemia', 'diabete', 'ipertensione', 'numerosi farmaci'];
export function About() {
  return <section className="w-full bg-navy-deep px-4 py-12 sm:px-6 sm:py-20" data-id="element-65" data-mp="yptiacu0i04m">
      <div className="mx-auto max-w-4xl" data-id="element-66" data-mp="b0sitf35pzbh">
        <div className="text-center" data-id="element-67" data-mp="axmui22cr1gt">
          <SectionLabel tone="dark" data-id="element-68" data-mp="6162gws182yg">Chi ha creato il sistema</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-white sm:text-4xl md:text-[42px]" data-id="element-69" data-mp="js14bp445jsj">
            La Dott.ssa Karito
          </h2>
          <p className="mt-2 text-[13px] font-bold uppercase tracking-[0.14em] text-white/55" data-id="element-70" data-mp="f019uc6tbj3c">
            Creatrice di Percorso Malattia Renale™
          </p>
        </div>

        <div className="mt-8 grid gap-7 sm:mt-12 sm:grid-cols-[minmax(0,320px)_minmax(0,1fr)] sm:items-start sm:gap-10" data-id="element-71" data-mp="3jehhs96o2d9s">
          <img src={KARITO_PHOTO} alt="La Dott.ssa Karito, creatrice di Percorso Malattia Renale™" className="mx-auto w-full max-w-[300px] rounded-3xl object-cover sm:max-w-none" width={936} height={1170} loading="lazy" data-id="element-72" data-mp="338ymc9zdn9s0" />

          <div className="flex flex-col gap-4 text-[14.5px] leading-relaxed text-white/75 sm:text-base" data-id="element-73" data-mp="3hxcxd86y64jn">
            <p data-id="element-74" data-mp="2kch0g977m43o">Per anni ho visto medici preparati affrontare lo stesso problema.</p>
            <p className="font-bold text-white" data-id="element-75" data-mp="2p9z71sxr878i">
              Non mancava loro la conoscenza. Mancava un modo rapido per trasformare
              quella conoscenza in una decisione clinica.
            </p>
            <p data-id="element-76" data-mp="2z8y6ckwmqqiu">
              Le linee guida contengono le informazioni. Ma quando hai davanti un
              paziente con:
            </p>
            <ul className="flex flex-wrap gap-2" data-id="element-77" data-mp="egwg6dkobsm2">
              {conditions.map(condition => <li key={condition} className="rounded-full bg-white/[0.08] px-3 py-1.5 text-[12.5px] font-semibold text-white/85" data-id="element-78" data-mp="2ak161os4y0tz">
                  {condition}
                </li>)}
            </ul>
            <p data-id="element-79" data-mp="2jiwdf46x1gyv">la domanda non è: “Dove posso trovare l’informazione?”</p>
            <p className="font-display text-[19px] font-bold italic leading-snug text-kidney-bright sm:text-2xl" data-id="element-80" data-mp="2fk5bmjri9b5f">
              “Cosa devo fare con QUESTO paziente, proprio adesso?”
            </p>
            <p data-id="element-81" data-mp="1mwjbxmleeqnu">
              Per questo ho creato Percorso Malattia Renale™. Non come un altro manuale
              da studiare. Non come una semplice raccolta di linee guida. Ma come un
              sistema clinico pratico che trasforma raccomandazioni complesse in
              percorsi decisionali chiari, rapidi e applicabili.
            </p>
            <p className="rounded-2xl bg-white/[0.06] px-4 py-4 font-semibold text-white" data-id="element-82" data-mp="144qenfzaqjab">
              Il mio obiettivo è semplice: fare in modo che tu possa entrare nella
              prossima visita renale con una mappa invece che con l’incertezza.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-md sm:mt-12" data-id="element-83" data-mp="k2m7k6nf6ct3">
          <CtaButton tone="cream" label="Voglio il percorso della Dott.ssa Karito" sub={`Sistema clinico completo • Pagamento unico di ${PRICE}`} data-id="element-84" data-mp="k46zrpm9hjns" />
        </div>
      </div>
    </section>;
}